
import {Component, Vue} from 'vue-property-decorator';
import {readUserProfileStats} from '@/store/main/getters';

@Component({})
export default class AllRegisteredForms extends Vue {
  private get userProfileStats() {
    return readUserProfileStats(this.$store)?.detailed;
  }

  private abbreviateNumberFunc(val) {
    return val.toLocaleString();
  }

}
